import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField from 'components/fields/TextField';
import AutosuggestField from 'components/fields/AutosuggestField';
import FormError from 'components/common/FormError';

import {
  updateClaimStatus,
} from 'redux/modules/claimStatuses';

import * as validate from 'utils/validate';

import objectDiff from 'utils/objectDiff';

import claimStatusCategories from 'config/claimStatusCategories';

const styles = () => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

function onSubmit(values, dispatch, props) {
  if (props.ID) {
    if (props.pristine) {
      throw new SubmissionError({
        _error: 'Nothing to submit',
      });
    }
    const diffValues = objectDiff(values, props.initialValues);
    return new Promise((resolve, reject) => {
      dispatch(updateClaimStatus({
        values: {
          ID: props.ID,
          ...diffValues,
        },
        resolve,
        reject,
      }));
    }).then(res => res,
      (err) => {
        throw new SubmissionError({ _error: err.error.indexOf('Unique check fail') !== -1
          ? 'Sorry, but such Claim Status already exists' : err.error });
      });
  }

  throw new SubmissionError({
    _error: 'Status creation not allowed',
  });
}

const validateForm = (values) => {
  const errors = {};

  if (values.Category
    && claimStatusCategories.indexOf(values.Category) == -1) {
    errors.Category = 'Please, select Category from list';
  }

  return errors;
};

const ClaimStatusCreateEditForm = ({
  handleSubmit,
  className,
  error,
  classes,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Status"
          name="Status"
          label="Status"
          component={TextField}
          validate={[validate.required]}
          errorPlacement="bottom"
          fullWidth
          disabled
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Category"
          name="Category"
          label="Category"
          component={AutosuggestField}
          errorPlacement="top"
          fullWidth
          renderSuggestionContent={suggestion => suggestion}
          onSuggestionSelected={suggestion => suggestion}
          fetchSuggestions={({ value }) => (new Promise((resolve) => {
            if (value.length > 0) {
              resolve(claimStatusCategories
                .filter(item => item.toLowerCase().indexOf(value.toLowerCase()) !== -1));
            } else {
              resolve(claimStatusCategories);
            }
          }))}
        />
      </Grid>
    </Grid>
  </form>
);

ClaimStatusCreateEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

ClaimStatusCreateEditForm.defaultProps = {
  className: '',
  error: null,
};

export default reduxForm({
  form: 'claimStatusEdit',
  onSubmit,
  validate: validateForm,
})(withStyles(styles)(ClaimStatusCreateEditForm));



// WEBPACK FOOTER //
// ./src/components/settings/ClaimStatusCreateEditDialog/ClaimStatusCreateEditForm.js